if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    jQuery('.navbar-toggler').on('click', function () {
        jQuery('body').toggleClass('nav-open');
    });

    jQuery('body').on('mouseover', '[data-dropdown]', function () {
        if (jQuery(window).width() > 768) {
            openSubmenu(jQuery(this));
        }
    });

    jQuery('body').on('mouseleave', 'header', function () {
        if (jQuery('body').hasClass('nav-open') && jQuery(window).width() > 768) {
            closeNavigation();
        }
    });

    jQuery('[data-dropdown]').on('click', function (e) {
        if (e.target.tagName == 'svg' || e.target.tagName == 'path' || jQuery(e.target).hasClass('bi-chevron-down')) {
            e.preventDefault();
            jQuery(this).toggleClass('show');
        }
    });
}

function openSubmenu($item) {
    if (!$item.hasClass('show')) {
        jQuery('[data-dropdown]').removeClass('show');
        $item.addClass('show');
        jQuery('body').addClass('nav-open');
    }
}

function closeNavigation() {
    jQuery('body').removeClass('nav-open');
    jQuery('[data-dropdown].show').removeClass('show');
}
